<template>
  <div class="servicios">
    <section id="almacenaje" class="almacenaje">
      <div class="section-header">
        <h1>1. Almacenaje</h1>
      </div>
      <div class="servicio-subheader mb-lg-5">
        <h2>
          ALMACENAJE DE PRODUCTOS EN DIFERENTES RAMOS (QUÍMICOS, PRODUCTOS GRADO
          ALIMENTICIO).
        </h2>
      </div>
      <div class="container">
        <div class="row mb-4 mb-lg-5">
          <div class="col-sm-12 col-md-8 col-xl-10">
            <div class="row">
              <div class="col-md-12 col-lg-6 almacen-desc">
                <h3>EL ALMACEN</h3>
                <h5>es una unidad de servicio.</h5>
                <p>
                  El almacén es una unidad de servicio y soporte en la
                  estructura orgánica y funcional de una compañía, comercial o
                  industrial, con propósitos bien definidos de custodia, control
                  y abastecimiento de materiales y productos. En la actualidad,
                  lo que antes se caracterizaba como un espacio dentro de la
                  empresa destinado al uso exclusivo de arrume de mercancía, es
                  una estructura clave que provee elementos físicos y
                  funcionales capaces de generar valor agregado.
                </p>
              </div>
              <div class="col-md-12 col-lg-6">
                <p>
                  El almacenaje es uno de los servicios logísticos más
                  importantes en la cadena de suministro de una empresa, ya que
                  además de albergar los productos en un espacio físico, se
                  realizan actividades de control, disponibilidad y
                  requerimiento de los productos, así como el traslado de los
                  mismos a los puntos de consumo o producción.
                </p>
                <p>
                  El almacén dejó de ser un simple espacio en el que se
                  guardaban los productos para convertirse en parte esencial del
                  negocio. Los escenarios emergentes en los mercados demandan la
                  reducción de tiempos de respuesta, la garantía de contar con
                  inventarios confiables y un óptimo servicio de entrega, todo
                  ello sin perder la calidad en la gestión del almacén.
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 col-xl-2">
            <div
              class="almacen-img-content h-100 d-flex justify-content-center align-items-center"
            >
              <img
                src="@/assets/images/almacen.jpg"
                alt
                class="img-fluid align-self-sm-center"
              />
            </div>
          </div>
        </div>
        <!-- row end -->
        <hr class="mb-3" />
        <h4>EL ALMACEN INCLUYE:</h4>
        <div class="row">
          <div class="col-md-4">
            <p>
              <strong>Recepción de productos:</strong> Se comprueba y registra
              el estado de los productos entrantes, así como la cantidad,
              calidad y otras características, de acuerdo a los requerimientos
              del cliente.
            </p>
            <p>
              <strong>Almacenamiento:</strong> Consiste en guardar los productos
              de tal manera que su acceso sea fácil.
            </p>
          </div>
          <div class="col-md-4">
            <p>
              <strong>Conservación y mantenimiento:</strong> Los productos
              deberán conservarse en perfecto estado durante su almacenaje,
              aplicando las normas de seguridad, salud y otros requerimientos
              vigentes.
            </p>
          </div>
          <div class="col-md-4 mb-3 mb-lg-4">
            <p>
              <strong>Administración de inventarios:</strong> Consiste en llevar
              un registro de las mercancías para mantener informado al cliente
              acerca de sus productos y la cantidad que mantiene en el almacén.
            </p>
            <p>
              <strong>Transporte:</strong> Una vez que se levanta el pedido del
              producto, se embala y envía según sus características y destino.
            </p>
          </div>
        </div>
        <hr class="mb-3" />
        <h4 class="mb-3 mb-lg-4">
          IMPORTANCIA Y OBJETIVOS DE LA GESTIÓN DE ALMACENES
        </h4>
        <div class="row">
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-12 col-lg-6">
                <p>
                  Describir la importancia y los objetivos de una gestión
                  dependen directamente de los fundamentos y principios que
                  enmarcan la razón de ser de la misma, sin embargo tal como lo
                  observamos en la gráfica anterior sobre el "debe ser
                  almacenado" quien formula las cuestiones de fundamento y
                  principio es la gestión de inventario o existencia, y en estas
                  se basa la gestión de almacenes para tener una gran
                  importancia y unos claros objetivos.
                </p>
              </div>
              <div class="col-md-12 col-lg-6 mb-3 mb-lg-4">
                <p>
                  Los objetivos que debe plantearse una gestión de almacenes
                  son:
                </p>
                <ul>
                  <li>Rapidez de entregas.</li>
                  <li>Fiabilidad.</li>
                  <li>Reducción de costes.</li>
                  <li>Maximización del volumen disponible.</li>
                  <li>
                    Minimización de las operaciones de manipulación y
                    transporte.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-3 mb-lg-4">
            <h3 class>SOLUCIONES ESPECÍFICAS</h3>
            <h5>de almacenamiento</h5>
            <p>
              Cada sector de actividad utiliza para el almacenaje de mercancías
              diferentes equipos de manipulación y soluciones específicas de
              almacenamiento con el fin de reducir costes y conseguir una mayor
              eficacia en el proceso de almacenaje; desde que se reciben los
              productos por parte de los proveedores hasta que los pedidos son
              servidos para enviárselos a los clientes.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section id="logistica" class="logistica">
      <div class="section-header mb-4 mb-lg-5">
        <h1>2. Logística</h1>
      </div>
      <div class="container">
        <div class="row justify-content-between mb-3 mb-lg-4">
          <div class="col-sm-12 col-lg-4 col-xl-4">
            <h3>¿QUÉ ES LA LOGÍSTICA?</h3>
            <h5>Implementación y control</h5>
            <p>
              Es una parte del proceso de la cadena de suministros, que planea,
              implementa y controla el eficiente y efectivo flujo y
              almacenamiento, hacia delante y en reversa de bienes, servicios e
              información relacionada del punto de origen al punto de consumo,
              con el propósito de satisfacer los requerimientos del cliente.
            </p>
          </div>
          <div class="col-sm-4 col-lg-4 col-xl-3 mb-3 mb-lg-4">
            <div class="logistica-image">
              <img
                class="img-fluid"
                src="@/assets/images/servicio-logistica.jpg"
                alt
              />
            </div>
          </div>
          <div class="col-sm-8 col-lg-4 col-xl-4">
            <h3>PROCESO DE ALMACENAJE</h3>
            <H5>Planificación y organización</H5>
            <p>
              El mapa de proceso de la gestion de almacenes se compone de dos
              ejes transversales que representan los procesos principales -
              Planificación y Organización y Manejo de la información - y tres
              subprocesos que componen la gestión de actividades y que abarca la
              recepción, el almacén y el movimiento.
            </p>
          </div>
        </div>
        <h4>OBJETIVO PRINCIPAL DE LA LOGÍSTICA DE ALMACENAMIENTO.</h4>
        <div class="row mb-3 mb-lg-4">
          <div class="col-lg-4">
            <p>
              El objetivo principal de la logística de almacenamiento consiste
              en ubicar las mercancías de la forma más adecuada reduciendo
              costos. Para ello, es necesario programar un flujo de mercancías y
              en la organización del almacén se establecen varios objetivos,
              entre los que destacan:
            </p>
          </div>
          <div class="col-sm-6 col-lg-4 mb-3 mb-lg-4">
            <ul>
              <li>
                Accesibilidad a todos los artículos haciendo el menor número de
                traslados.
              </li>
              <li>Rotación controlada del stock.</li>
              <li>
                Facilidad a la hora de llevar a cabo los recuentos, el
                inventario y conocer el estado en el que se encuentran los
                productos.
              </li>
              <li>
                Máximo aprovechamiento de la capacidad de almacenaje, tanto en
                superficie como en altura.
              </li>
            </ul>
          </div>
          <div class="col-sm-6 col-lg-4 mb-3 mb-lg-4">
            <div
              class="logistica-image d-flex align-items-center justify-content-center"
            >
              <img
                src="@/assets/images/servicio-logistica-2.svg"
                alt
                class="img-fluid"
              />
            </div>
          </div>
        </div>
        <hr class="mb-3" />
        <div class="row">
          <div class="col-md-8 mb-3 mb-lg-4 frase">
            <div class="row frase-top">
              <div class="col-md-6">
                <h4>Planificación y organización</h4>
                <p>
                  El proceso de planificación y organización es de carácter
                  estratégico y táctico, dado que tiene que brindar soluciones
                  de recursos en comunión con las políticas y objetivos
                  generales que contempla la estrategia de la compañía, en aras
                  de potenciar las ventajas competitivas por las que apuesta la
                  misma.
                </p>
              </div>

              <div class="col-md-6 mb-3 mb-lg-4">
                <h6>Recepción</h6>
                <p>
                  El flujo rápido del material que entra, para que esté libre de
                  toda congestión o demora, requiere de la correcta planeación
                  del área de recepción y de su óptima utilización. La recepción
                  es el proceso de planificación de las entradas de unidades,
                  descarga y verificación tal y como se solicitaron mediante la
                  actualización de los registros de inventario.
                </p>
              </div>
            </div>
            <div class="row frase-bottom">
              <div class="col-12 mb-3 mb-lg-4">
                <div class="logistica-frase py-4 px-5 text-center">
                  <h4>
                    LA FUNCIÓN PRINCIPAL DE LA GESTIÓN DE ALMACENES ES LA
                    EFICIENCIA Y EFECTIVIDAD EN EL FLUJO FÍSICO. DEBE SER SU
                    OPTIMIZACIÓN, POR TANTO, EL OBJETIVO DE PRIMER ORDEN.
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-3 mb-lg-4">
            <h6>Movimiento</h6>
            <p>
              Es el subproceso del almacén de carácter operativo relativo al
              traslado de los materiales/productos de una zona a otra de un
              mismo almacén o desde la zona de recepción a la ubicación de
              almacenamiento. La actividad de mover físicamente mercancías se
              puede lograr por diferentes medios, utilizando una gran variedad
              de equipos de manipulación de materiales. El tipo de herramientas
              utilizado depende de una serie de factores como son:
            </p>
            <ul>
              <li>Volumen del almacén.</li>
              <li>Volumen de las mercancías.</li>
              <li>Vida de las mercancías.</li>
              <li>Costo del equipo frente a la finalidad.</li>
              <li>
                Cantidad de manipulaciones especiales y expediciones requeridas.
              </li>
              <li>Distancia de los movimientos.</li>
              <li>Información.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section id="controldeinventarios" class="controldeinventarios">
      <div class="section-header mb-4 mb-lg-5">
        <h1>3. Control de Inventarios</h1>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-md-4 mb-3 mb-lg-4">
            <h3 class="mb-3 mb-lg-4">Control de Inventarios</h3>
            <p>
              La gestión de inventarios es un punto determinante en el manejo
              estratégico de toda organización. Las tareas correspondientes al
              control de un inventario se relacionan con la determinación de los
              métodos de registro, los puntos de rotación, las formas de
              clasificación y los modelos de reinventario, determinados por los
              métodos de control.
            </p>
          </div>
          <div class="col-sm-6 col-md-4 px-4 mb-3 mb-lg-4">
            <div class="controldeinventarios-frases">
              <h6>Los objetivos fundamentales del controlde inventario son:</h6>

              <p>Reducir al minimo "posible" los niveles de esxitencias.</p>
              <div class="line"></div>
              <p>Asegurar la disponibilidad de existencias.</p>
            </div>
          </div>
          <div class="col-md-4 mb-3 mb-lg-4">
            <h3>Mantenimiento de Inventario</h3>
            <p>
              El mantenimiento de un inventario (administrado por la
              organización) se ven preponderantemente determinados por la
              permanencia de la media de las unidades logísticas en un lugar
              determinado para ello en función del tiempo, dado que cada unidad
              representa un costo de manipulación en los procesos de recepción,
              almacenamiento, inspección y despacho.
            </p>
          </div>
        </div>
        <div class="container px-md-5 px-lg-3 contoldeinventarios-banner mb-4">
          <div class="row inventario-row mx-md-n5 mx-lg-n3 p-4 p-lg-3">
            <div
              class="col-md-12 col-lg-4 px-md-5 px-lg-3 d-flex align-items-center justify-content-center"
            >
              <h3 class="mb-3 mb-lg-4">PRINCIPALES OBJETIVOS DEL INVENTARIO</h3>
            </div>
            <div
              class="col-md-6 col-lg-4 justify-content-centercol-lg-4 px-md-5 px-lg-3"
            >
              <ul>
                <li>
                  Mitigación de las fluctuaciones de la demanda, ofreciendo un
                  aseguramiento contra las incertidumbres del mercado.
                </li>
                <li>
                  Facilita un rol proactivo ante los cambios previstos en la
                  oferta y la demanda.
                </li>
              </ul>
            </div>
            <div class="col-md-6 col-lg-4 px-md-5 px-lg-3">
              <ul>
                <li>
                  Permite un flujo continuo de los procesos de manufactura y
                  ensamble, otorgándole flexibilidad a los procesos de
                  programación.
                </li>
                <li>
                  Mejora los procesos de compra-venta de suministros y
                  materiales, teniendo la posibilidad de aprovechar descuentos
                  por volumen.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <h3 class="mb-3 mb-lg-4">Pasos para realizar un inventario</h3>
        <div class="row mb-3 mb-lg-4">
          <div class="col-md-6 col-lg-4">
            <ol>
              <li class="mb-2">
                <strong>Identificar los bienes a inventariar:</strong> El primer
                paso es tener claro qué bienes son los que corresponde
                inventariar y qué bienes no.
              </li>
              <li>
                <strong>Determinar los lugares a inventariar:</strong> tener
                presente todos los lugares en los que están los bienes para no
                omitirlos; recorrer esos lugares y ordenarlos, si es que no lo
                están, a fin de poder identificar sin problemas los bienes y
                evitar reiteraciones u omisiones.
              </li>
            </ol>
          </div>
          <div class="col-md-6 col-lg-8">
            <div class="row">
              <div class="col-md-12 col-lg-6">
                <ol start="3">
                  <li>
                    <strong>Armar un equipo de trabajo:</strong> Consideramos de
                    suma importancia este tema porque además de hacer la tarea
                    de manera más eficiente, es una muestra de solidaridad y
                    corresponsabilidad por parte de las personas que hacen parte
                    del almacén.
                  </li>
                </ol>
              </div>
              <div class="col-md-12 col-lg-6">
                <ol start="4">
                  <li>
                    <strong>Recorrido, recuento y registro:</strong> Una vez
                    cumplidos los pasos anteriores estamos en condiciones de
                    comenzar el inventario propiamente dicho. Un detalle a tener
                    en cuenta es el riesgo de no inventariar algún objeto, o de
                    contarlo más de una vez.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="mejoradeproducto" class="mejoradeproducto">
      <div class="section-header mb-4 mb-lg-5">
        <h1>4. Mejora de Producto</h1>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-4 mb-3 mb-lg-4">
            <h3 class="mb-3 mb-lg-4">Maquila de empaques</h3>
            <p>
              Nuestro servicio de maquila en empaques, ofrece a nuestros
              clientes la garantía en la ejecución efectiva y calidad en el
              proceso, aportando una disminución de costos por traslado de la
              mercancía y manipulación.
              <br />Contamos con los equipos y el personal capacitado para
              desempeñar esta actividad de acuerdo a los estándares exigidos por
              nuestros clientes, garantizando siempre óptimas operaciones que
              garantizan la disponibilidad del producto para el cliente en el
              momento oportuno al mejor costo.
            </p>
          </div>
          <div class="col-md-8 mb-3 mb-lg-4">
            <h3 class="mb-3 mb-lg-4">
              Servicio de Maquila y Preparación de Producto
            </h3>
            <div class="row">
              <div class="col-12">
                <p>
                  Los servicios de maquila y preparación de productos cuentan
                  con un requerimiento que mejora la calidad de almacenamiento
                  de mercancía; entre los que se puede contar los siguientes:
                </p>
              </div>
              <div class="col-sm-6 col-md-6">
                <ul class="mb-0">
                  <li>Etiquetado.</li>
                  <li>
                    Colocación de textos legales en productos de consumo masivo.
                  </li>
                  <li>Etiquetas pre-impresas.</li>
                  <li>
                    Empacado de material en presentaciones de 4, 6 o más
                    unidades dependiendo de los requerimientos del cliente.
                  </li>
                </ul>
              </div>
              <div class="col-sm-6 col-md-6 mb-3 mb-lg-4">
                <ul>
                  <li>
                    Cambio del empaque secundario (caja corrugada) cuando esta
                    presenta deterioro.
                  </li>
                  <li>Pegado de solapas.</li>
                  <li>Desempacado.</li>
                  <li>Clasificación de productos.</li>
                  <li>Repaletizados.</li>
                  <li>Trabajos de recuperación.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr class="mb-3" />
        <div class="row">
          <div class="col-md-4 mb-3 mb-lg-4">
            <div class="mejoradeproducto-image">
              <img
                class="img-fluid w-100"
                src="~@/assets/images/mejoradeproducto-1.jpg"
                alt="Hombre trabajando en planta"
              />
            </div>
          </div>
          <div class="col-md-4 mb-3 mb-lg-4">
            <h5>Empaques sellados</h5>
            <p>
              El empaquetado y sellado de contenedores, cajas o recipientes
              garantizan la permanencia del producto en condiciones óptimas, el
              cual se sustituye en determinado períodos dependiendo del tiempo
              de permanencia dentro de nuestros almacenes.
            </p>
          </div>
          <div class="col-md-4 mb-3 mb-lg-4">
            <h5>Horno</h5>
            <p>
              Prestar el servicio de horno al calor, ayuda a tener
              presentaciones bien seguras, fácil de contabilizar y manejables
              para su transporte.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-4 mb-3 mb-lg-4">
            <h5>Trasegado</h5>
            <p>
              Un servicio importante dentro de nuestra cartera de operaciones
              logísticas, es ofrecerles a nuestros clientes el trasiego de
              líquidos de contenedores de mayor capacidad a contenedores de
              menor capacidad. Bajo esta modalidad nuestro personal se encuentra
              ampliamente capacitado en el manejo, vaciado y llenado de fluidos
              para trasegar líquidos de un recipiente a otro.
            </p>
          </div>
          <div class="col-md-6 col-lg-4 mb-3 mb-lg-4">
            <div class="mejoradeproducto-image">
              <img
                class="img-fluid"
                src="~@/assets/images/mejoramientodeproducto-2.jpg"
                alt="Trabajador haciendo trascegado de productos"
              />
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-3 mb-lg-4">
            <p>
              Otra de las actividades a nivel de trasegado, es el proceso de
              reacondicionamiento de materiales de consumo masivo a fin de que
              estos sean acondicionados para la venta, así como el vertido del
              contenido (líquidos) tales como: lavaplatos, desinfectantes,
              suavizantes, entre otros a tambores de 200 Kg para su posterior
              disposición por parte del cliente, este proceso va acompañado del
              control de inventario y la distribución del material al destino
              indicado por el cliente.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="sericiospreferentes" id="serviciospreferentes">
      <div class="section-header mb-4 mb-lg-5">
        <h1 class="servicio-title">5. Servicios Preferentes</h1>
      </div>
      <div class="container">
        <div class="container">
          <div class="row">
            <div class="col-md-4 mb-3 mb-lg-4">
              <h3 class="mb-3 mb-lg-4">Cross Docking</h3>
              <p>
                Dicho de una manera simple, el cross docking es una técnica que
                ayuda a optimizar el tiempo de almacenaje, haciéndolo
                inexistente o muy limitado. El proceso hace que la mercancía no
                se quede en el almacén o que cuando llegue, ésta salga
                directamente a los clientes.
                <br />Contratar el servicio de cross docking implica transferir
                la mercancía del medio de transporte en el que llegan al medio
                de transporte en el que salen, sin que existan stocks o medie un
                almacenaje intermedio. <br />De esta manera –y como su nombre lo
                indica–, se acelera el proceso de recepción de los productos en
                el punto de entrada, para que en el menor tiempo posible puedan
                ser transferidos al transporte saliente.
              </p>
            </div>
            <div class="col-md-4 mb-3 mb-lg-4">
              <h3 class="mb-3 mb-lg-4">Ventajas del Cross Docking</h3>
              <ul>
                <li>
                  Logra mejorar la eficiencia y la productividad dentro de la
                  cadena de suministro.
                </li>
                <li>
                  Es un modelo de distribución especialmente rápido y rentable.
                </li>
                <li>
                  Permite tener una interesante reducción de costos en:
                  almacenaje, distribución, inventario y personal.
                </li>
                <li>
                  Al reducir los stocks, facilita la tarea de manipulación y
                  reubicación de la mercancía, consiguiendo un número menor de
                  errores.
                </li>
                <li>
                  Consigue una mayor frescura de la mercancía y aumenta su
                  disponibilidad.
                </li>
              </ul>
            </div>
            <div class="col-md-4 mb-3 mb-lg-4">
              <ul>
                <li>
                  Facilita el cumplimiento de los plazos fijados, lo que supone
                  una gran ventaja para el cliente.
                </li>
              </ul>
              <p>
                Cabe destacar que esta técnica es ideal para ciertas industrias,
                sobre todo cuando se trabaja con artículos sin conservadores o
                que tengan la necesidad de transportarse a una temperatura
                controlada. También es propicia para productos envasados y
                ordenados, pues estarán listos para el transporte o para un
                cliente específico.
              </p>
              <img
                class="img-fluid w-100"
                src="~@/assets/images/serviciospreferentes.jpg"
                alt
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Servicios',
}
</script>

<style lang="scss" scoped>
ul {
  list-style: disc;
  padding-left: 15px;
}
ol {
  list-style: decimal;
  padding-left: 15px;
}

.servicio-subheader {
  margin-bottom: $spacer;
  background-image: url('~@/assets/images/logistica-frase-bg.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  h2 {
    color: #fff;
    padding: 20px;
    font-size: 1.3rem;
    text-align: center;
  }
}
.frase {
  display: flex;
  flex-direction: column;
  .frase-bottom {
    flex-grow: 2;
    .logistica-frase {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      h4 {
        margin: 0;
      }
    }
  }
}
.logistica-frase {
  background-image: url('~@/assets/images/logistica-frase-bg.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: $naranja;
  align-self: stretch;
}
.controldeinventarios-frases {
  min-height: 280px;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 15px;
  background-color: $azul;
  background-image: url('~@/assets/images/plano3.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  color: #fff;
  font-size: 0.9rem;
  h6 {
    color: $naranja;
  }
  p {
    margin: 0;
  }
}

.line {
  height: 1px;
  width: 30px;
  background-color: $naranja;
}
.inventario-row {
  background-color: $azul;
  background-image: url('~@/assets/images/logistica-frase-bg.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  h3 {
    color: $naranja;
  }
}
</style>
